import type { CSSProperties } from "react";
import { Toaster as Sonner } from "sonner";
import { CircleCheck, CircleX, Info, TriangleAlert, LoaderCircle } from "lucide-react";
import { useTheme } from "@/shared/hooks/useTheme";

export function Toaster() {
  const { theme, darkMode } = useTheme();
  const resolvedTheme = theme === 'system' ? (darkMode ? 'dark' : 'light') : theme;
  return (
    <Sonner
      theme={resolvedTheme}
      style={{
        "--normal-bg": "var(--card)",
        "--normal-border": "var(--border)",
        "--normal-text": "var(--card-foreground)",
      } as CSSProperties & Record<string, string>}
      position="top-center"
      duration={5000}
      closeButton
      icons={{
        success: <CircleCheck className="h-5 w-5 text-emerald-500" />,
        error: <CircleX className="h-5 w-5 text-red-500" />,
        info: <Info className="h-5 w-5 text-blue-500" />,
        warning: <TriangleAlert className="h-5 w-5 text-amber-500" />,
        loading: <LoaderCircle className="h-5 w-5 text-blue-500 animate-spin" />,
      }}
    />
  );
}
